import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

export default function ReferEarn() {
  const [data, setData] = useState(null);
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    axios.get('/api/customer/referrals').then(r => setData(r.data)).catch(() => {});
    axios.get('/api/customer/referrals/leaderboard').then(r => setLeaderboard(r.data)).catch(() => {});
  }, []);

  const copy = (text) => {
    navigator.clipboard.writeText(text).then(() => toast.success('Copied!')).catch(() => {});
  };

  const refLink = `${window.location.origin}/register?ref=${data?.referralCode}`;

  return (
    <div>
      <div className="page-header">
        <Link to="/home" className="back-btn">←</Link>
        <h1>Refer & Earn 🎁</h1>
      </div>
      <div className="page-content">
        <div className="card" style={{ background: 'linear-gradient(135deg, #1A6B8A, #0e4d6b)', color: 'white', textAlign: 'center' }}>
          <p style={{ fontSize: 32, marginBottom: 8 }}>🎁</p>
          <p style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>Earn 200 Points Per Referral</p>
          <p style={{ fontSize: 13, opacity: 0.85 }}>Invite friends and earn loyalty points</p>
          <div style={{ background: 'rgba(255,255,255,0.15)', borderRadius: 10, padding: '12px', marginTop: 16 }}>
            <p style={{ fontSize: 22, fontWeight: 800, letterSpacing: 2 }}>{data?.referralCode}</p>
            <p style={{ fontSize: 11, opacity: 0.7 }}>Your Referral Code</p>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
          <button onClick={() => copy(data?.referralCode)} className="btn btn-outline btn-sm" style={{ flex: 1 }}>📋 Copy Code</button>
          <button onClick={() => copy(refLink)} className="btn btn-primary btn-sm" style={{ flex: 1 }}>🔗 Copy Link</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 16 }}>
          <div className="stat-card">
            <p className="value">{data?.totalReferrals || 0}</p>
            <p className="label">Total Referrals</p>
          </div>
          <div className="stat-card">
            <p className="value">{data?.totalPoints || 0}</p>
            <p className="label">Points Earned</p>
          </div>
        </div>

        {leaderboard.length > 0 && (
          <>
            <p className="section-title" style={{ marginTop: 16 }}>🏆 Monthly Leaderboard</p>
            {leaderboard.map((u, i) => (
              <div className="card" key={i} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ fontSize: 20 }}>{i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `#${i + 1}`}</span>
                <div style={{ flex: 1 }}>
                  <p style={{ fontWeight: 600, fontSize: 14 }}>{u.full_name}</p>
                  <p style={{ fontSize: 12, color: '#6b7280' }}>{u.shipping_mark}</p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ fontWeight: 700, color: '#1A6B8A' }}>{u.total_referrals} refs</p>
                  <p style={{ fontSize: 11, color: '#6b7280' }}>{u.total_points} pts</p>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
